import React from "react";

const ConfirmationModal = ({id,lable,handleYes}) => {
  return (
    <div
      className="modal fade"
      id={id}
      tabIndex="-1"
      aria-labelledby="ct_delete_classLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-0">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body border-0 pt-0">
            <img src="img/mdi_cross-circle.svg" className="rc_w_60" />
            <h4 className="text-center mb-4 ct_fs_18 mt-2">
              Are you sure you want to {lable}
            </h4>
          </div>
          <div className="modal-footer border-0 justify-content-center pt-0">
            <button
              type="button"
              onClick={handleYes}
              className="ct_custom_btn1"
              data-bs-dismiss="modal"
            >
              Yes
            </button>
            <button
              type="button"
              className="ct_custom_btn1 ct_outline_btn_12"
              data-bs-dismiss="modal"
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
